import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Header from "./header";
import ActivityTimestampBanners from "../common/activity-timestamp-banners";
import axios from "axios";

class ActivityDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      error: null,
      history: null,
      centrale: {
        to_prepare: 0,
        to_dispatch: 0,
        labels: 0,
        missing: 0,
      },
      magasins: {
        to_prepare: 0,
        to_dispatch: 0,
        sav: 0,
        missing: 0,
      },
    };
  }

  getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
  });

  getActivityCounts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/store/activity-dashboard`,
        {
          headers: this.getAuthHeaders(),
        }
      );
      if (response.data?.status === "Success" && response.data?.data) {
        const { centrale, magasins, history } = response.data.data;
        this.setState({
          error: null,
          history: history || null,
          centrale: {
            to_prepare: centrale?.to_prepare || 0,
            to_dispatch: centrale?.to_dispatch || 0,
            labels: centrale?.labels || 0,
            missing: centrale?.missing || 0,
          },
          magasins: {
            to_prepare: magasins?.to_prepare || 0,
            to_dispatch: magasins?.to_dispatch || 0,
            sav: magasins?.sav || 0,
            missing: magasins?.missing || 0,
          },
        });
        return;
      }
      this.setState({
        error: "Impossible de charger les données du tableau de bord.",
      });
    } catch (err) {
      console.log(err);
      this.setState({
        error: "Impossible de charger les données du tableau de bord.",
      });
    }
  };

  loadDashboard = async () => {
    this.setState({ loader: true, error: null, history: null });
    try {
      await this.getActivityCounts();
    } catch (err) {
      console.log(err);
      this.setState({
        error: "Impossible de charger les données du tableau de bord.",
      });
    } finally {
      this.setState({ loader: false });
    }
  };

  componentDidMount() {
    this.loadDashboard();
  }

  renderMetricRow = (label, value, colorClass) => (
    <div className={`activity-metric-row activity-metric-${colorClass}`}>
      <div className="activity-metric-label">{label}</div>
      <div className="activity-metric-value">{value}</div>
    </div>
  );

  renderSection = (title, metrics, missing) => (
    <div className="col-lg-6 mb-4">
      <h4 className="activity-section-title text-center mb-3">{title}</h4>
      <div className="activity-dashboard-section">
        {this.renderMetricRow("Nbre CMD à préparer", metrics.to_prepare, "prepare")}
        {this.renderMetricRow("Nbre CMD à expédier", metrics.to_dispatch, "dispatch")}
        {this.renderMetricRow(metrics.thirdLabel, metrics.thirdValue, "extra")}
        <div className="activity-missing-box">
          <div className="activity-missing-label">MANQUANTS</div>
          <div className="activity-missing-value">{missing}</div>
        </div>
      </div>
    </div>
  );

  render() {
    const { loader, error, history, centrale, magasins } = this.state;

    return (
      <div className="w-100 activity-dashboard-page">
        <Header />
        <div className="mx-5 my-4">
          <h3 className="text-center mb-4">Danielli Activity</h3>

          <ActivityTimestampBanners history={history} skipFetch />

          {loader ? (
            <div className="text-center p-4">
              <div className="loader1">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : error ? (
            <div className="text-center p-4">
              <p className="text-danger mb-3">{error}</p>
              <button
                type="button"
                className="btn btn-bg border rounded text-white"
                onClick={this.loadDashboard}
              >
                Réessayer
              </button>
            </div>
          ) : (
            <div className="row activity-dashboard-columns justify-content-center">
              {this.renderSection("CENTRALE", {
                to_prepare: centrale.to_prepare,
                to_dispatch: centrale.to_dispatch,
                thirdLabel: "Etiquettes à traiter",
                thirdValue: centrale.labels,
              }, centrale.missing)}
              {this.renderSection("MAGASINS", {
                to_prepare: magasins.to_prepare,
                to_dispatch: magasins.to_dispatch,
                thirdLabel: "S.A.V à traiter",
                thirdValue: magasins.sav,
              }, magasins.missing)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ActivityDashboard;
